var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64172 12.9841C7.48338 12.9841 7.32505 12.9258 7.20005 12.8008C6.95838 12.5591 6.95838 12.1591 7.20005 11.9174L11.9167 7.20078C12.1584 6.95911 12.5584 6.95911 12.8 7.20078C13.0417 7.44245 13.0417 7.84245 12.8 8.08411L8.08338 12.8008C7.96672 12.9258 7.80005 12.9841 7.64172 12.9841Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3584 12.9841C12.2 12.9841 12.0417 12.9258 11.9167 12.8008L7.20005 8.08411C6.95838 7.84245 6.95838 7.44245 7.20005 7.20078C7.44172 6.95911 7.84172 6.95911 8.08338 7.20078L12.8 11.9174C13.0417 12.1591 13.0417 12.5591 12.8 12.8008C12.675 12.9258 12.5167 12.9841 12.3584 12.9841Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.98b7e70681c60e4277afa8e217039c38.svg";
export { ForwardRef as ReactComponent };